import { Menu as DefaultMenu } from 'react-feather';
import styled from 'styled-components';

export const Menu = styled(DefaultMenu)`
	color: #f5f6f7;
	flex-shrink: 0;
	height: 1rem;
	transition: filter 0.2s ease-in-out;
	width: 1rem;
	:hover {
		filter: brightness(125%);
	}
`;
